<mat-card appearance="outlined">
  <mat-card-content>
    <mat-form-field style="min-width: 50%;">
      <mat-label>Select Material</mat-label>
      <input
        required="required"
        type="text"
        aria-label="Material Selection"
        matInput
        [(ngModel)]="setting.value"
        (ngModelChange)="onSearchTextChanged($event)"
        [matAutocomplete]="materialAutoComplete">
      <mat-autocomplete
        #materialAutoComplete="matAutocomplete"
        autoActiveFirstOption
        [displayWith]="displayMaterialName">
        <mat-option *ngFor="let option of options; trackBy: getIdentifierForIterableItem" [value]="option"
                    (onSelectionChange)="onOptionsChanged(option)">
          <span>{{ option.number + ' - ' + option.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </mat-card-content>
</mat-card>

